type IDs = {
  testId: string
  'data-testid': string
}

export const addTestId = (id: string): IDs => {
  const testId = `cm-${id}`
  return { testId, 'data-testid': testId }
}
